import { BlueprintInstanceType } from '@rta/rta-blueprint-library';

import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';
import { isSwappableAppliance } from '../helpers/is-swappable-appliance';

export const swapApplianceMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Swap appliance',
		onClick: ({ context, controller }): void => {
			controller.publishRequestedAction('swap_appliance', context.id);
		},
		isVisible: ({ refMap, controller }): boolean => {
			// const { ui } = appState;
			// const refEntry = controller.kitchen?.getReferenceMap(ui.pointer.context.ref.id);

			// Don't continue if we are not dealing with a PanelItem
			if (controller.readonly || refMap?.type !== BlueprintInstanceType.PanelItem) return false;

			return isSwappableAppliance(refMap.panelItem);
		}
	};
};
